import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Login from './login/Login';
import ProtectedRoute from './login/ProtectedRoute';
import UnauthorizedPage from './login/Unauthorized';
// import MainLayout from './general/MainLayout';
import MainLayout from './general/MainLayout';
import SuperUserCreateClient from './general/superus';

function App() {
  localStorage.setItem('currentPath', window.location.pathname);

  return (
    <Routes>
        <Route path="/*" element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        } />
      
      <Route path="/" element={<Login />} />
      
      {/* <Route path="/un$!&+*au4#th-superusor*@ized" element={<UnauthorizedPage />} /> */}
      <Route path="/un$!&+*au4" element={<SuperUserCreateClient />} />
      <Route
        path="/send-email"
      />
    </Routes>
  );
}

export default App;
